import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../libs/shared/helpers/src/browser/hoverHelpers';

/*
 * Props.
 */

interface ColorDotProps {
  /** Size of the dot. */
  size: number;
  color: string;
  hoverColor?: string;
  borderColor?: string;
  className?: string;
}

/*
 * Style.
 */

export interface ColorDotStyleProps {
  $size: number;
  $color: string;
  $hoverColor?: string;
  $borderColor?: string;
}

const StyledColorDiv = styled.div<ColorDotStyleProps>`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  background-color: ${(p) => p.$color};

  ${hoverSelector} {
    background-color: ${(p) => p.$hoverColor || p.$color};
  }

  border: ${(p) => (p.$borderColor ? `2px solid ${p.$borderColor}` : 'none')};
`;

/*
 * Component.
 */

export const ColorDot: FC<ColorDotProps> = (props) => (
  <StyledColorDiv
    $size={props.size}
    $color={props.color}
    $hoverColor={props.hoverColor}
    $borderColor={props.borderColor}
    className={props.className}
  />
);
